// Local: src/components/Products/Financeiro/services/api.js

import api from '../../../../services/api'; 

const authHeader = () => ({});

// --- Produtos ---
export const getProdutos = async () => {
  const res = await api.get('/financeiro/produtos', { headers: authHeader() });
  return res.data;
};
export const createProduto = async (data) => {
  const res = await api.post('/financeiro/produtos', data, { headers: authHeader() });
  return res.data;
};
export const updateProduto = async (id, data) => {
  const res = await api.put(`/financeiro/produtos/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deleteProduto = async (id) => {
  await api.delete(`/financeiro/produtos/${id}`, { headers: authHeader() });
};

// --- Contratos ---
export const getContratos = async () => {
  const res = await api.get('/financeiro/contratos', { headers: authHeader() });
  return res.data;
};
export const createContrato = async (data) => {
  const res = await api.post('/financeiro/contratos', data, { headers: authHeader() });
  return res.data;
};
export const updateContrato = async (id, data) => {
  const res = await api.put(`/financeiro/contratos/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deleteContrato = async (id) => {
  await api.delete(`/financeiro/contratos/${id}`, { headers: authHeader() });
};
export const getContratosParaSelecao = async () => {
  const res = await api.get('/financeiro/contratos-para-selecao', { headers: authHeader() });
  return res.data;
};

// --- Pagamentos ---
export const getPagamentos = async () => {
  const res = await api.get('/financeiro/pagamentos', { headers: authHeader() });
  return res.data;
};
export const createPagamento = async (data) => {
  const res = await api.post('/financeiro/pagamentos', data, { headers: authHeader() });
  return res.data;
};
export const updatePagamento = async (id, data) => {
  const res = await api.put(`/financeiro/pagamentos/${id}`, data, { headers: authHeader() });
  return res.data;
};
export const deletePagamento = async (id) => {
  await api.delete(`/financeiro/pagamentos/${id}`, { headers: authHeader() });
};

// --- Restaurantes (para o seletor) ---
export const getRestaurantes = async () => {
  const res = await api.get('/financeiro/restaurantes', { headers: authHeader() });
  return res.data;
};

// --- Geração de Pagamentos ---
export const gerarPrevisaoPagamentos = async () => {
  const res = await api.post('/financeiro/pagamentos/gerar-previsao', {}, { headers: authHeader() });
  return res.data;
};

// --- Categorias de Despesas ---
export const getCategoriasDespesas = async () => {
  const res = await api.get('/financeiro/despesas/categorias', { headers: authHeader() });
  return res.data;
};

// --- Despesas ---
export const getDespesas = async () => {
  const res = await api.get('/financeiro/despesas', { headers: authHeader() });
  return res.data;
};

export const createDespesa = async (data) => {
  const res = await api.post('/financeiro/despesas', data, { headers: authHeader() });
  return res.data;
};

export const updateDespesa = async (id, data) => {
  const res = await api.put(`/financeiro/despesas/${id}`, data, { headers: authHeader() });
  return res.data;
};

export const deleteDespesa = async (id) => {
  await api.delete(`/financeiro/despesas/${id}`, { headers: authHeader() });
};

export const gerarDespesasRecorrentes = async () => {
  const res = await api.post('/financeiro/despesas/gerar-recorrentes', {}, { headers: authHeader() });
  return res.data;
};

export const listDespesasRecorrentes = async () => {
  const res = await api.get('/financeiro/despesas/recorrentes', { headers: authHeader() });
  return res.data;
};

// --- Dashboard ---
export const getDashboardSummary = async () => {
  const res = await api.get('/financeiro/dashboard', { headers: authHeader() });
  return res.data;
};

export const updateCaixa = async (valor) => {
  const res = await api.put('/financeiro/dashboard/caixa', { valor }, { headers: authHeader() });
  return res.data;
};

export const getDashboardAnalytics = async () => {
  const res = await api.get('/financeiro/dashboard/analytics', { headers: authHeader() });
  return res.data;
};

// --- Metas (NOVO) ---
export const getMetas = async () => {
  const res = await api.get('/financeiro/metas', { headers: authHeader() });
  return res.data;
};

export const updateMetas = async (data) => {
  const res = await api.put('/financeiro/metas', data, { headers: authHeader() });
  return res.data;
};
